import $ from "jquery";
import "./scripts/slick-carousel.js";

import "../scss/page.scss";
import "../scss/contact.scss";

import "./scripts/single-career/activecampaign-newsletter.js";
import "./scripts/map-load.js";

var carousel = $('.section--contact__expert');
var carousel2 = $('.map_slider');

carousel.on('init', function(event, slick) {
    setTimeout( function() {
        carousel.addClass('loaded');
    }, 1000);
});

carousel.slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: true,
    fade: true,
    autoplaySpeed: 3500,
    responsive: [
        {
          breakpoint: 1140,
          settings: {
            slidesToShow: 1
          }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});

carousel2.on('init', function(event, slick) {
    setTimeout( function() {
        carousel.addClass('loaded');
    }, 1000);
});

carousel2.slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: false,
    fade: true,
    prevArrow:'<button class="slick-arrow slick-prev" aria-label="Prev"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="11" viewBox="0 0 13 11" fill="none" transform="matrix(-1, 0, 0, 1, 0, 0)"><path d="M12.957 5.25864L8.25003 0.551638C8.15719 0.458794 8.04696 0.385145 7.92566 0.334898C7.80435 0.284651 7.67433 0.258789 7.54303 0.258789C7.41173 0.258789 7.28171 0.284651 7.16041 0.334898C7.0391 0.385145 6.92888 0.458794 6.83603 0.551638C6.74319 0.644483 6.66954 0.754705 6.61929 0.876013C6.56904 0.99732 6.54318 1.12734 6.54318 1.25864C6.54318 1.38994 6.56904 1.51996 6.61929 1.64126C6.66954 1.76257 6.74319 1.87279 6.83603 1.96564L9.12903 4.25864L1.54303 4.25864C1.27781 4.25864 1.02346 4.364 0.835924 4.55153C0.648388 4.73907 0.543031 4.99342 0.543031 5.25864C0.543031 5.52385 0.648388 5.77821 0.835924 5.96574C1.02346 6.15328 1.27781 6.25864 1.54303 6.25864L9.12903 6.25864L6.83603 8.55164C6.74285 8.64429 6.6689 8.75445 6.61844 8.87579C6.56797 8.99712 6.542 9.12723 6.542 9.25864C6.542 9.39005 6.56797 9.52016 6.61843 9.64149C6.6689 9.76282 6.74285 9.87299 6.83603 9.96564C7.02356 10.1531 7.27787 10.2584 7.54303 10.2584C7.8082 10.2584 8.0625 10.1531 8.25003 9.96564L12.957 5.25864Z" fill="#222222"/></svg></button>',
    nextArrow:'<button class="slick-arrow slick-next" aria-label="Next"><svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.957 5.25864L8.25003 0.551638C8.15719 0.458794 8.04696 0.385145 7.92566 0.334898C7.80435 0.284651 7.67433 0.258789 7.54303 0.258789C7.41173 0.258789 7.28171 0.284651 7.16041 0.334898C7.0391 0.385145 6.92888 0.458794 6.83603 0.551638C6.74319 0.644483 6.66954 0.754705 6.61929 0.876013C6.56904 0.99732 6.54318 1.12734 6.54318 1.25864C6.54318 1.38994 6.56904 1.51996 6.61929 1.64126C6.66954 1.76257 6.74319 1.87279 6.83603 1.96564L9.12903 4.25864L1.54303 4.25864C1.27781 4.25864 1.02346 4.364 0.835924 4.55153C0.648388 4.73907 0.543031 4.99342 0.543031 5.25864C0.543031 5.52385 0.648388 5.77821 0.835924 5.96574C1.02346 6.15328 1.27781 6.25864 1.54303 6.25864L9.12903 6.25864L6.83603 8.55164C6.74285 8.64429 6.6689 8.75445 6.61844 8.87579C6.56797 8.99712 6.542 9.12723 6.542 9.25864C6.542 9.39005 6.56797 9.52016 6.61843 9.64149C6.6689 9.76282 6.74285 9.87299 6.83603 9.96564C7.02356 10.1531 7.27787 10.2584 7.54303 10.2584C7.8082 10.2584 8.0625 10.1531 8.25003 9.96564L12.957 5.25864Z" fill="#222222"/></svg></button>',
    responsive: [
        {
            breakpoint: 1140,
            settings: {
                slidesToShow: 1
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 1
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});
